export const SET_LANGUAGE = 'LANGUAGE/SET_LANGUAGE'
export const SET_LANGUAGES = 'LANGUAGE/SET_LANGUAGES'
